// src/pages/LoginPage.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Seo from "../components/Generic/Seo"; //
import LoginForm from "../components/Registration/LoginForm";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import { isLoggedIn } from "../utility/UserUtils";

const LoginPage = () => {
  const navigate = useNavigate();

  const seoData = {
    title:
      "WiSE Login — Access Your Account | Women in Semiconductor Ecosystem",
    description:
      "Login to your WiSE account to access mentorship, event resources, community forums and member-only features within the Women in Semiconductor Ecosystem.",
    keywords:
      "WiSE login, women in semiconductor login, member login WiSE, access WiSE account, login women in tech community, semiconductor member login",
    pathSlug: "login",
  };

  useEffect(() => {
    if (isLoggedIn()) {
      toast.info("You’re already logged in");
      navigate("/", { replace: true });
    }
  }, []);

  return (
    <>
      <Seo data={seoData} />

      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <div className="auth-page">
        <LoginForm />
      </div>
    </>
  );
};

export default LoginPage;
